import { DecodedToken } from '../../types/auth/DecodedToken';
import { UserHelper } from './UserHelper';
import { CurrentUser } from '../../types/auth/User';
import Cookies from 'js-cookie';
import { StorageHelper } from './StorageHelper';

export class JWTHelper {
    // &#x1f539; Tenta obter o token do storage, e se não existir, do cookie (apenas se não for HttpOnly)
    static getTokenFromStorage(): string | undefined {
        const currentUser = UserHelper.getCurrentUser();
        if (currentUser?.token) {
            return currentUser.token;
        }

        // &#x1f539; Tentativa fallback para SSO
        const ssoToken = Cookies.get('token');
        return ssoToken;
    }

    static getTokenFromCookie(): string | undefined {
        const tokenCookie = Cookies.get('token');
        return tokenCookie;
    }

    static getSSOIdTokenFromStorage(): string | undefined {
        // Obtem o token ID do SSO
        const ssoIdToken = Cookies.get('ssoIdToken');
        return ssoIdToken;
    }

    static getSSOChallengeDeviceFromStorage(): string | undefined {
        // Obtem o desafio a completar ex.: SMS
        const ssoChallengeDevice = Cookies.get('ssoChallengeDevice');
        return ssoChallengeDevice;
    }

    static getSSOChallengeSessionFromStorage(): string | undefined {
        // Obtem o desafio a completar ex.: SMS
        const ssoChallengeSession = Cookies.get('ssoChallengeSession');
        return ssoChallengeSession;
    }

    static decode(token?: string): DecodedToken | undefined {
        if (token) {
            try {
                const payload = token.split('.')[1];
                const decoded = JSON.parse(atob(payload));
                return decoded;
            } catch (e) {
                console.error('[JWT] ❌ Erro ao decodificar token:', e);
            }
        }
    }

    static isExpired(token?: string): boolean {
        if (token) {
            const decodedToken = JWTHelper.decode(token);
            if (decodedToken) {
                const expired = Date.now() >= decodedToken.exp * 1000;
                if (expired) {
                    console.warn('[JWT] ⚠️ Token expirado');
                }
                return expired;
            }
        }
        return true;
    }

    // &#x1f501; Se o token estiver HttpOnly e não for acessível, buscar via endpoint `/auth/me`
    static async fetchUserFromServer(): Promise<CurrentUser | undefined> {
        const start = performance.now();

        try {
            const response = await fetch('/auth/me', {
                method: 'GET',
                credentials: 'include', // &#x1f510; envia cookie junto
                headers: {
                    Accept: 'application/json',
                },
            });

            const duration = (performance.now() - start).toFixed(0);

            // &#x1f50d; Log detalhado de erro ou resposta
            if (!response.ok) {
                const body = await response.text();
                console.warn('[Auth] ❌ Falha ao buscar /auth/me:', `${response.status} ${response.statusText}`);
                console.warn('[Auth] ❗ Resposta do servidor:', body);
                console.log('----------------------------------------------');
                return;
            }

            const user = await response.json();

            const storage = new StorageHelper().getStorage();
            storage.setItem('portalHomeCareAuth', JSON.stringify(user));
            return user;
        } catch (err: any) {
            console.error('[JWTHelper] &#x1f525; Erro ao buscar usuário via /auth/me:', err.message || err);
            console.log('----------------------------------------------');
        }
    }
}
